import {UUID} from '../../../shared/types/uuid.type';
import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, map, tap} from 'rxjs/operators';
import {forkJoin, Observable, of} from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';
import {
  startManyProductionInstances,
  startManyProductionInstancesFailure,
  startManyProductionInstancesSuccess
} from './production-instance.start-many.actions';
import {ProductionInstancesService} from '../../../services/api/production-instances/production-instances.service';
import {ProductionInstance} from '../../../services/api/production-instances/production-instance.model';
import {loadVmixServers, manyProductionInstancesStatusChanged} from '../actions/vmix-servers.actions';


@Injectable()
export class ProductionInstanceStartManyEffects {

  // noinspection JSUnusedGlobalSymbols
  startManyProductionInstances$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(startManyProductionInstances),
        concatMap((payload: { ids: UUID[] }) => {
          const ids: UUID[] = payload.ids;
          const requests: Observable<ProductionInstance>[] = ids
            .map((id: UUID): Observable<ProductionInstance> =>
              this.service.start(id)
            );

          return forkJoin(requests)
            .pipe(
              map(() => startManyProductionInstancesSuccess({ids: ids})),
              catchError((error: any) => of(startManyProductionInstancesFailure({error: error})))
            );
        }));
  });

  // noinspection JSUnusedGlobalSymbols
  startManyProductionInstancesSuccess$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(startManyProductionInstancesSuccess),
        tap(() =>
          this.snackBar.open('Production Instances successfully started', 'Success', {duration: 3000})),
        map((data: { ids: UUID[] }) =>
          manyProductionInstancesStatusChanged({ids: data.ids, status: 'starting'})
        )
      );
  });

  // noinspection JSUnusedGlobalSymbols
  startManyProductionInstancesFailure$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(startManyProductionInstancesFailure),
        tap((error: { error: any }) =>
          this.snackBar.open(`Failed to start production instances: ${error.error}`, 'Error', {duration: 3000})),
        map(() => loadVmixServers())
      );
  });

  constructor(
    private readonly actions$: Actions,
    private readonly service: ProductionInstancesService,
    private readonly snackBar: MatSnackBar
  ) {
  }

}
